import { render, staticRenderFns } from "./YoutubeUpload.vue?vue&type=template&id=32dd6ba2&"
import script from "./YoutubeUpload.vue?vue&type=script&lang=js&"
export * from "./YoutubeUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports